export default import.meta.ROLLDOWN_FILE_URL_aKo4wVjMjV9S8rY28E5Mvg